import { Box, styled } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import FeatureItem from './FeatureItem';

const Wrapper = styled(Box)(({ theme }) => ({
  padding: theme.spacing(7, 2),
}));

const logo = () => {
  if (import.meta.env.VITE_SITE === 'Paybilt') {
    return '/images/paybilt.png';
  } else {
    return '/images/payper.png';
  }
};

const Features = () => {
  return (
    <Wrapper>
      <Box ml={3}>
        <img src={logo()} width={100} alt={import.meta.env.VITE_SITE} />
      </Box>

      <Box mt={3} pr={4}>
        <FeatureItem
          icon={<CheckCircle />}
          title="Get started quickly"
          desc="Integrate with developer-friendly APIs or choose low-code or pre-built solutions."
        />

        <FeatureItem
          icon={<CheckCircle />}
          title="Support any business model"
          desc="E-commerce, subscriptions, SaaS platforms, marketplaces, and more—all within a unified platform."
        />

        <FeatureItem
          icon={<CheckCircle />}
          title="Join millions of businesses"
          desc={`${
            import.meta.env.VITE_SITE
          } is trusted by ambitious startups and enterprises of every size.`}
        />
      </Box>
    </Wrapper>
  );
};

export default Features;
